module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/hd-xumiao-manifesto.700ef441.png";